import { RNG } from '../rng'
import { COLORS } from '../constants'

export interface Piece {
  color1: number  // main block (pivot)
  color2: number  // sub block
}

/**
 * Generates an infinite deterministic sequence of pieces from a seed.
 * Both client and server use the same seed so the sequence is identical
 * without synchronising each individual piece over the network.
 */
export class PieceGenerator {
  private rng: RNG

  constructor(seed: number) {
    this.rng = new RNG(seed)
  }

  next(): Piece {
    return {
      color1: (this.rng.nextInt(COLORS)) + 1,
      color2: (this.rng.nextInt(COLORS)) + 1,
    }
  }
}
